import * as React from 'react';
import { isNil } from 'ramda';
import { isUndefined } from '@cian/newbuilding-utils';
import * as styles from './Select.css';
import { Button } from '../Button';
import { SelectionList } from '../SelectionList';

import { ClickOutside } from '../outside';
import { MountPopup } from '../PopupViewer';
import { Container } from '../Container';

export interface IMultilineVariants {
  id: string;
  label: string;
}

export interface ISelectMultilineProps {
  text?: string;
  placeholder: string;
  options: Array<IMultilineVariants>;
  onChange?(value: string): void;
  value?: string[];
}

export interface ISelectMultilineState {
  selected: string[];
  isOpen?: boolean;
}

export class SelectMultiline extends React.PureComponent<ISelectMultilineProps, ISelectMultilineState> {

  public state: Readonly<ISelectMultilineState> = {
    selected: this.props.value || [],
    isOpen: false,
  };
  public fakeSelect: HTMLSelectElement;

  public componentWillReceiveProps(nextProps: ISelectMultilineProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({selected: nextProps.value || []});
    }
  }

  public render() {
    const {
      text,
      options,
      placeholder,
    } = this.props;
    const { selected, isOpen } = this.state;

    return (
      <label
        data-mark="SelectMultiline"
        className={styles['hidden-select-handler']}
        data-style="select_component">
        <select
          onChange={({currentTarget}) => this.handleChange({ id: currentTarget.value })}
          value={selected}
          multiple
          tabIndex={-1}
          ref={(select) => select && (this.fakeSelect = select)}
          className={styles['hidden-select']}
        >
          {options.map(({label, id}) => (
            <option key={id} value={id}>{label}</option>
          ))}
        </select>

        <MountPopup
          placement="bottom"
          component={
            isOpen &&
            <ClickOutside onOutside={this.handleBlur}>
              <Container overflow="hidden" shadow>
                <div className={styles['list']}>
                  <SelectionList options={options} selectedItems={selected} multiline onClick={this.handleChange} />
                </div>
              </Container>
            </ClickOutside>
          }
        >
          <Button
            type="light"
            normalText={true}
            icon={isOpen ? 'chevronUp' : 'chevronDown'}
            iconSize={10}
            reverse
            tabIndex={-1}
            onClick={this.handleToggle}
            className={isOpen ? styles['select-button-clicked'] : ''}
          >
            {isUndefined(text)
              ? placeholder
              : text
            }
          </Button>
        </MountPopup>
      </label>
    );
  }

  private handleChange = ({ id }: { id: string, label?: string }) => {
    if (isNil(this.props.value)) {
      let selected = [];
      let isFinded = false;

      for (let item of this.state.selected) {
        if (item === id) {
          isFinded = true;
        } else {
          selected.push(item);
        }
      }

      if (!isFinded) {
        selected.push(id);
      }

      this.setState({selected});
    }

    if (this.props.onChange) { this.props.onChange(id); }
  }

  private handleToggle = () => {
    const { isOpen } = this.state;

    this.setState({ isOpen: !isOpen });
  }

  private handleBlur = () => {
    this.setState({ isOpen: false });
  }
}
